module.exports = __webpack_public_path__ + "static/img/建筑智能化_中央空调系统3@2x.8f0a37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download1/建筑智能化_中央空调系统3@2x.png
// module id = Xf22
// module chunks = 1